import React from 'react';

import { Checkbox } from '@material-ui/core';
import { get } from 'lodash';
import PropTypes from 'prop-types';

import CheckboxWithInfo from 'components/CheckboxWithInfo/CheckboxWithInfo';

const FormCheckboxTile = ({ label, formik, id, required, ...rest }) => {
  const { values, handleChange } = formik;
  const checked = get(values, id) || false;
  const unifiedLabel = required ? `${label} * ` : label;

  return (
    <CheckboxWithInfo
      checked={checked}
      control={<Checkbox data-testid={`${id}-checkbox-tile`} />}
      label={unifiedLabel}
      onChange={handleChange(id)}
      required={required}
      selected={checked}
      {...rest}
    />
  );
};

FormCheckboxTile.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  formik: PropTypes.shape({
    values: PropTypes.shape({}),
    handleChange: PropTypes.func,
  }).isRequired,
  required: PropTypes.bool,
};

FormCheckboxTile.defaultProps = {
  required: false,
};

export default FormCheckboxTile;
